import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { Tag } from 'Components/frameworks/tag/Tag';
export type OfferDiscountProps = {
  className?: string;
  discount:
    | {
        amount?: {
          formattedValue: string;
          value?: number;
        };
        offerColor?: Colors;
        offerName?: string;
      }
    | null
    | undefined;
  i18n:
    | {
        defaultLabel?: string;
        defaultColor?: Colors;
      }
    | null
    | undefined;
};
export const OfferDiscount = ({ className, discount, i18n }: OfferDiscountProps) => {
  const offerName = discount?.offerName || i18n?.defaultLabel || '';
  const backgroundColor = discount?.offerColor || i18n?.defaultColor || null;
  return discount?.amount?.value ? (
    <Tag
      className={classnames('text-white', className)}
      style={{
        backgroundColor,
        borderColor: backgroundColor,
      }}
    >
      {offerName}
    </Tag>
  ) : null;
};
